import React, { useState, useEffect } from "react";
import moment from "moment";
import useWidth from "../hooks/useWidth";
import {Button, Box, Typography, Grid } from "@mui/material";
import AuthenticationMetricsComponent from "../components/authentication/authentication-metrics.component";
import AuthenticationGraphComponent from "../components/authentication/authentication-graph.component";
import AuthenticationTabsComponent from "../components/authentication/authentication-tab/authentication-tab.component";
import AuthenticationMetricsFilterComponent from "../components/authentication/authentication-filters/authentication-metrics-filter.component";
import useAuthentication from '../hooks/useAuthentication';
import OfflineIcon from "../assets/images/offline.png";
import useFilters from "../hooks/useFilters";

const AuthenticationScreen = () => {
    const breakpoints = useWidth();
    const { isFetchingTotalAuthentication, getAuthenticationCount, totalAuthenticationCount, getAuthenticationStatus, 
        totalAuthenticationStatus, getAuthenticationFailRate, authenticationFailRateData, getAuthenticationDateTypeCount,
        authenticationDateTypeCount, isFetchingAuthenticationFailRate, isFetchingAuthenticationStatus, isFetchingAuthenticationCount,
        getAuthenticationDateTypeCountFilterByName,  getAuthenticationCountFilterByName, getAuthenticationStatusFilterByName, getAuthenticationFailRateFilterByName } = useAuthentication();

    const {getListFilterProduct, listProducts} = useFilters();

    const [productName, setProductName] = useState("");

    const [startDate, setStartDate] = useState(moment().subtract(6, 'days').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));

    const [isOnline, setOnline] = useState(navigator.onLine);

    useEffect(() => {
        getListFilterProduct();
    }, [])

    useEffect(() => {
        const handleOnline = () => setOnline(true);
        const handleOffline = () => setOnline(false);
    
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        }
    },  []);

    useEffect(() => {
        console.log("aaa Product Name:", productName, productName?.value);

        if (productName) {
            getAuthenticationDateTypeCountFilterByName(startDate, endDate, productName?.value);
            getAuthenticationCountFilterByName(startDate, endDate, productName?.value);
            getAuthenticationStatusFilterByName(startDate, endDate, productName?.value);
            getAuthenticationFailRateFilterByName(startDate, endDate, productName?.value);

        } else {
            getAuthenticationCount(startDate, endDate);
            getAuthenticationStatus(startDate, endDate);
            getAuthenticationFailRate(startDate, endDate);
            getAuthenticationDateTypeCount(startDate, endDate);
        }
    }, [startDate, endDate, productName]);  

   
    const handleDateRangeChange = (newStartDate, newEndDate) => {
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    }

    const handleSelectProductFilter = (selectedOption) => {
        if (!selectedOption) {
            setProductName("");

        } else {
            setProductName(selectedOption);
        }
    }
    

    return (
        <Box>
            {(isOnline) ?  
                <>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h6" sx={{ color: "#58565f", fontWeight: 600, fontSize: 20 }}>
                                Authentication
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container spacing={2} sx={{ justifyContent: "flex-end", alignItems: "center" }}>
                                <Grid item xs={12} >
                                    <AuthenticationMetricsFilterComponent 
                                        handleDateRangeChange={handleDateRangeChange} 
                                        productName={productName}
                                        listProducts={listProducts}
                                        handleSelectProductFilter={handleSelectProductFilter}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} sx={{ mt: 1 }}>
                            <AuthenticationMetricsComponent 
                                breakpoints={breakpoints} 
                                isFetchingTotalAuthentication={isFetchingTotalAuthentication} 
                                totalAuthenticationCount={totalAuthenticationCount} 
                            />
                        </Grid>

                        <Grid item xs={12} sx={{ mt: 3 }}>
                            <AuthenticationGraphComponent 
                                totalAuthenticationStatus={totalAuthenticationStatus} 
                                authenticationFailRateData={authenticationFailRateData} 
                                authenticationDateTypeCount={authenticationDateTypeCount}
                                isFetchingAuthenticationFailRate={isFetchingAuthenticationFailRate}
                                isFetchingAuthenticationStatus={isFetchingAuthenticationStatus}
                                isFetchingAuthenticationCount={isFetchingAuthenticationCount}
                                breakpoints={breakpoints}
                            />
                        </Grid>
                    </Grid>

                    <Box sx={{ mt: 5 }} />

                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h6" sx={{ color: "#58565f", fontWeight: 600, fontSize: 20 }}>
                                Authentication Logs
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <AuthenticationTabsComponent />
                        </Grid>
                    </Grid>
                </>
            :
                <>
                    <Grid item xs={12}>
                        <Typography variant="h6" sx={{ color: "#58565f", fontWeight: 600, fontSize: 20 }}>
                            Authentication
                        </Typography>
                    </Grid>

                    <Box sx={{textAlign: "center", mt: 20}}>  
                        <img alt="" src={OfflineIcon} style={{height: 80, marginBottom: "16px"}} />

                        <Typography sx={{fontSize: 20, fontWeight: "bold", mb: 0.5, color: "#58565f"}}>
                            Ooops!
                        </Typography>

                        <Typography sx={{color: "#58565fd4"}}>
                            Failed to load data.
                        </Typography>

                        <Typography sx={{color: "#58565fd4"}}>
                            Please check your internet connection or try again.
                        </Typography>

                        <Button variant="contained" sx={{mt: 2.5, bgcolor: '#3333cf', textTransform:'none'}} onClick={() => window.location.reload()}>
                            Try again
                        </Button>
                    </Box>
                </>
            }
        </Box>
    )
}

export default AuthenticationScreen
